import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { Label } from 'core';
import { FormField } from 'core/components/form';
import { Card } from 'core/components/card';
import infoIcon from 'core/assets/svg/info-icon-dark.svg';

import useStyles from './changes-for-approval-section.styles';

const AllHouseholdResidentsIncludedBlock = ({ isProcessingView = false }) => {
  const classes = useStyles();

  if (isProcessingView) {
    return (
      <Card type="primary" className={clsx(classes.pipChangeContainer, classes.pipChangeProcessingUserContainer)}>
        <img src={infoIcon} alt="info" />
        <div>
          <Label type="darkGreenSmallBold">Check PIP household residents.</Label>
          <p className={classes.pipChangeDescription}>
            Please review any changes to the drivers and/or other household residents to confirm that those changes are
            correctly accounted for in the finalized list of household residents on the PIP tab.
          </p>
        </div>
      </Card>
    );
  }

  return (
    <Card type="primary" className={classes.pipChangeContainer}>
      <Label type="darkGreenSmallBold">Please make sure you’ve included all residents of the household</Label>
      <p className={classes.pipChangeDescription}>
        Include children and non-driving relatives, even if they’re away at college or on military service. This ensures
        PIP protection for everyone in case of a car accident.
      </p>
      <FormField
        mode="light"
        label="I confirm that all household residents are included."
        type="checkbox"
        id="allHouseholdResidentsIncludedAttestation"
        name="allHouseholdResidentsIncludedAttestation"
        ignoreGlobalDisabledState
      />
    </Card>
  );
};

AllHouseholdResidentsIncludedBlock.propTypes = {
  isProcessingView: PropTypes.bool.isRequired
};

export default AllHouseholdResidentsIncludedBlock;
